import { WorkSearch, WorkSearchSchema } from "@models/work";
import { createBrowseUrlParams, DEFAULT_SORT_KEY, DEFAULT_SORT_METHOD, ParsedBrowseUrl } from "@features/tickets/shared/utils/browseUrlParams";

export { DEFAULT_SORT_KEY, DEFAULT_SORT_METHOD };
export type ParsedWorksUrl = ParsedBrowseUrl<WorkSearch>;

const worksBrowseUrl = createBrowseUrlParams<WorkSearch>(WorkSearchSchema);

export const parseWorksUrlParams = worksBrowseUrl.parseBrowseUrlParams;
export const syncWorksUrlParams = worksBrowseUrl.syncBrowseUrlParams;
